import { Box } from "@mui/material"
import { shippingInvoiceColNm } from "branch/pages/ShippingProcess/constant"
import ComboBox from "components/ComboBox"
import { GlobalStateContext } from "contexts/GlobalStateContext"
import CustomerDialog from "pages/Menu2/CustomerManagement/CustomerDialog"
import { useCallback, useContext, useMemo, useState } from "react"


const CusComboWithAdd = ({ dialogData, setDialogData, sx, required }) => {

  const { msData } = useContext(GlobalStateContext)
  const [dialogCusOpen, setDialogCusOpen] = useState(false)
  const handleSelectCusCombo = useCallback((id) => {

    setDialogData(o => {
      if (id === -1) {
        setDialogCusOpen(true)
      }
      return { ...o, CusId: id }
    })
  }, [setDialogData])

  const onDialogCusFinish = useCallback(async (id) => {
    setDialogData(o => ({ ...o, CusId: id }))
  }, [setDialogData])

  const customerDialogPropsMemo = useMemo(() => {
    return {
      state: { dialogOpen: dialogCusOpen, selectedCusId: 0 },
      fn: {
        setDialogOpen: setDialogCusOpen,
        onFinish: onDialogCusFinish
      }
    }
  }, [dialogCusOpen, onDialogCusFinish])
  return (
    <Box>
      <ComboBox sx={sx} options={msData.cusComboWithAdd} label={shippingInvoiceColNm.CusSNm}
        selectedId={dialogData.CusId} required={required}
        setSelectedId={handleSelectCusCombo}
      />
      <CustomerDialog {...customerDialogPropsMemo} />
    </Box>
  )
}

export default CusComboWithAdd